import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ProductGroup } from '../../components/product-group/ProductGroup';
import { productGroupActions } from '../../redux/productGroup/actions/ProductGroupActions.creators';
import { makeGetProductGroupState } from '../../redux/productGroup/selectors/ProductGroupSelectors';
import { useProductTileHelpers } from '../../hooks/useProductTileHelpers';
import { ProductAddToBasketLocations } from '../../enums/ActionEnums';
import { useFeatureToggle } from '../../hooks/useFeatureToggle';
const ProductGroupContainer = ({ productGroupId, title, tileFormat, deliveryPromiseExplanations, collapsed, collapsible, }) => {
    var _a;
    const lowest_price_all = useFeatureToggle('lowest_price_all');
    const dispatch = useDispatch();
    const { handleWishlistToggle, handleUpdateCompareList, handleAddToBasket, compareItems } = useProductTileHelpers();
    const productGroup = useSelector(makeGetProductGroupState());
    const getDeliveryPromise = (payload) => dispatch(productGroupActions.getDeliveryPromise(Object.assign(Object.assign({}, payload), { productGroupId })));
    useEffect(() => {
        var _a;
        if (productGroupId && ((_a = productGroup === null || productGroup === void 0 ? void 0 : productGroup[productGroupId]) === null || _a === void 0 ? void 0 : _a.length)) {
            dispatch(productGroupActions.init());
        }
    }, []);
    if (!productGroupId || !((_a = productGroup === null || productGroup === void 0 ? void 0 : productGroup[productGroupId]) === null || _a === void 0 ? void 0 : _a.length)) {
        return null;
    }
    return (_jsx(ProductGroup, { addToBasket: (...args) => handleAddToBasket(...args, ProductAddToBasketLocations.PRODUCT_GROUP), collapsed: collapsed, collapsible: collapsible, compareItems: compareItems, deliveryPromiseExplanations: deliveryPromiseExplanations, getDeliveryPromise: getDeliveryPromise, onWishListToggle: handleWishlistToggle, products: productGroup[productGroupId], productGroupId: `product-group-${productGroupId}`, productTileFormat: tileFormat, title: title, updateCompareList: handleUpdateCompareList, enablePriceReference: lowest_price_all }));
};
export default ProductGroupContainer;
